export default {
  methods: {
    onSharingPopupOpened() {
      const vm = this;
    },
    onSharingPopupClosed() {
      const vm = this;
    },
  }
}